import { render, staticRenderFns } from "./AgencyForm.vue?vue&type=template&id=ba1db130&scoped=true&"
import script from "./AgencyForm.vue?vue&type=script&lang=ts&"
export * from "./AgencyForm.vue?vue&type=script&lang=ts&"
import style0 from "./AgencyForm.vue?vue&type=style&index=0&id=ba1db130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1db130",
  null
  
)

export default component.exports